import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export const TEAM_PASSCODE_OK = 'ok';
export const TEAM_PASSCODE_NO_MATCH = 'no_match';
export const TEAM_PASSCODE_MAP_NO_TEAM = 'passcode_map_no_team';

const validateTeamPasscodeCallable = httpsCallable(functions, 'validateTeamPasscode');

/**
 * Resolve a team by passcode for a given event via Cloud Function.
 * teamPasscodes is admin-only in Firestore rules; the callable uses Admin SDK.
 * @param {string} eventId
 * @param {string} passcodeRaw
 * @returns {Promise<{ team: object|null, status: string }>}
 */
export async function matchTeamByPasscodeForEvent(eventId, passcodeRaw) {
  if (!passcodeRaw || !eventId) {
    return { team: null, status: TEAM_PASSCODE_NO_MATCH };
  }
  try {
    const result = await validateTeamPasscodeCallable({ eventId, passcode: passcodeRaw });
    const { status, team } = result.data;
    return { team: team || null, status };
  } catch (err) {
    return { team: null, status: TEAM_PASSCODE_NO_MATCH };
  }
}
